/** Follow-up calls. Shapes follow workers/api/src/home/followups.ts on `main`. */
import type { ApiClient } from "./client";

export interface Subject { type: "member" | "lead"; id: string; name: string | null; phone: string | null }

export interface FollowupItem {
  /** Holds `:`; URL-encode it. */
  key: string;
  kind: "renewal" | "due" | "inactive" | "lead_first_response" | "lead_trial" | (string & {});
  subject: Subject;
  dueAt: number | null;
  dueDate: string | null;
  overdue: boolean;
  ownerStaffId: string | null;
  ownerName: string | null;
  /** Paise, only with `see_revenue`. */
  amountDue?: number;
}
export interface FollowupsResult { date?: string; items: FollowupItem[]; truncated: boolean; omitted: string[] }
export interface FollowupQuery { date: string; branchId?: string; ownerStaffId?: string }

export async function fetchFollowups(c: ApiClient, q: FollowupQuery): Promise<FollowupsResult> {
  const r = await c.get<{ date?: string; items?: FollowupItem[]; followups?: FollowupItem[]; truncated?: boolean; omitted?: string[] }>("/followups", { date: q.date, branchId: q.branchId, ownerStaffId: q.ownerStaffId });
  return { date: r.date, items: r.items ?? r.followups ?? [], truncated: r.truncated ?? false, omitted: r.omitted ?? [] };
}
export const doneFollowup = (c: ApiClient, key: string) => c.post<unknown>(`/followups/${encodeURIComponent(key)}/done`);
export const snoozeFollowup = (c: ApiClient, key: string, until: string) => c.post<unknown>(`/followups/${encodeURIComponent(key)}/snooze`, { until });
